var map = {
	"./de/scholarlevels": [
		"mJde",
		33
	],
	"./en/scholarlevels": [
		"bP2C",
		17
	],
	"./fr/scholarlevels": [
		"/BvT",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ZyYT";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/scholarlevels$
// module id = ZyYT
// module chunks = 70